import { memo } from 'react';
import { PreferenceOption } from '@mark43/cad-api';
import { Text, VStack } from '@cad-arc';
import { FormBooleanRadioGroup } from '../forms/integrated-form-controls/form-boolean-radio-group';
import { useIntegratedForm } from '../forms/use-integrated-form';
import { PreferencesFormType } from './types';

export const ThemePreferences = memo(function ThemePreferences({
    fields,
    isFirstResponder,
}: {
    fields: PreferenceOption[];
    isFirstResponder: boolean;
}) {
    const { form } = useIntegratedForm<PreferencesFormType>();

    // Find the light mode preference index
    const lightModePreferenceKey = isFirstResponder
        ? 'FIRST_RESPONDER_LIGHT_MODE_ENABLED'
        : 'CAD_LIGHT_MODE_ENABLED';

    const preferenceIndex = fields.findIndex((f) => f.preference === lightModePreferenceKey);

    // If preference not found, don't render anything
    if (preferenceIndex === -1) {
        return null;
    }

    return (
        <VStack alignItems="flex-start" data-testid="cad-fr-theme-preferences">
            <Text fontSize="sm" color="tertiary" as="b">
                Theme
            </Text>
            <FormBooleanRadioGroup
                name={`preferences.${preferenceIndex}.value`}
                items={[
                    { label: 'Dark', value: false },
                    { label: 'Light', value: true },
                ]}
                control={form.control}
                radioGroupProps={{ direction: 'column' }}
            />
        </VStack>
    );
});
